import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'
import { withNamespaces } from 'react-i18next';
import loader from '../../Comman/images/loader.gif'
import SimpleReactValidator from 'simple-react-validator';
import swal from 'sweetalert';
import imageCompression from 'browser-image-compression';
import { Editor } from 'primereact/editor';
import { baseUrl } from '../../Comman/apiEndPoints';

const options = {
    maxSizeMB: 2.0,          // (default: Number.POSITIVE_INFINITY)
    maxWidthOrHeight: 600,   // compressedFile will scale down by ratio to a point that width or height is smaller than maxWidthOrHeight (default: undefined)
    useWebWorker: true,      // optional, use multi-thread web worker, fallback to run in main-thread (default: true)
    maxIteration: 10        // optional, max number of iteration to compress the image (default: 10)
}

const sleep = (milliseconds) => {
    return new Promise(resolve => setTimeout(resolve, milliseconds))
}

var svValidator;
var engValidator;
var currentLang;

class CompanyBrandingComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            SigningText: '',
            CreatedBy: '',
            ImageName1: '',
            SigningText: '',
            BackGroundImage: '',
            BackGroundImage1: '',
            ImageName2: '',
            BannerImage:'',
              BannerImage1:''
        }
        this.handleInput = this.handleInput.bind(this);

        if (sessionStorage.getItem('Language')) {
            currentLang = sessionStorage.getItem('Language');
        }
        else {
            currentLang = "en";
        }
    }
    componentWillReceiveProps(nextProps) {
        // console.log("next", nextProps);
        /* if (nextProps.getLogoSettingData.Message != this.props.getLogoSettingData.Message) {
            if (nextProps.getLogoSettingData.statusCode == 200) {
                swal(nextProps.getLogoSettingData.Message, {
                    icon: "success",
                });
                this.props.getApplicationLogoData();
            }
        } */
      // this.props.GetCompanyBrandingData();
        this.translateLang();
    }
    translateLang() {
        var language;
        if (sessionStorage.getItem('Language')) {
            language = sessionStorage.getItem('Language');
        }
        else {
            language = "en";
        }
        if (language == "en") {
            this.validator = engValidator;
        }
        else {
            this.validator = svValidator;
        }
    }
    componentWillMount() {
        SimpleReactValidator.addLocale('en', {
            required: 'The :attribute field is required.',
            min: 'The :attribute must be at least :min:type.'
        });
        SimpleReactValidator.addLocale('sv', {
            required: 'Fältet :attribute krävs.',
            min: ':attribute måste vara minst :min tecken.'
        });
        engValidator = new SimpleReactValidator(
            {
                locale: 'en'
            }
        );
        svValidator = new SimpleReactValidator(
            {
                locale: 'sv'
            }
        );
        this.validator = engValidator;
    }
    componentDidUpdate(prevProps) {
        
        if (prevProps.getCompanyBrandingData != this.props.getCompanyBrandingData) {
            if (this.props.getCompanyBrandingData.brandList[0]) {
                let data = this.props.getCompanyBrandingData.brandList[0] ? this.props.getCompanyBrandingData.brandList[0]: null;
                this.setState({
                    BackGroundImage1:baseUrl + data.BackGroundImage,
                    SigningText:data.SigningText,
                    BannerImage1:baseUrl + data.BannerImage,
                    
                })
            }
        }
        sleep(500).then(() => {
            console.log("setstate", this.state);
        })
    }
    handleInput(e) {
        this.setState({
            SigningText: e.htmlValue
        })
    }
    save() {
        const formData = new FormData();
        formData.append('SigningText', this.state.SigningText)
        formData.append('ImageName1', this.state.ImageName1)
        formData.append('CreatedBy', sessionStorage.getItem('SuperAdminUserID'))
        formData.append('BackGroundImage', this.state.BackGroundImage)
        formData.append('ImageName2',this.state.ImageName2)
        formData.append('BannerImage', this.state.BannerImage )
        this.props.addCompanyBranding(formData);
    }
    
    ImageName1Upload = (event) => {
        let file = event.target.files[0];
        var self = this;
        let reader = new FileReader();
        imageCompression(file, options)
            .then(function (compressedFile) {
                self.setState({ Image: compressedFile })
                reader.readAsDataURL(compressedFile);
                reader.onloadend = function () {
                    debugger
                    // self.setState(prevState => ({ newCarouselData : 
                    //     {...prevState.newCarouselData,
                    //         PageLogo: reader.result,
                    //     },
                    //     }))
                    self.setState({ BackGroundImage: reader.result,BackGroundImage1: reader.result,ImageName1:file.name })
                }
            })
            .catch(function (error) {
                console.log(error);
            });
        // let reader = new FileReader();
        // reader.onload = () => {
        //     this.setState({ image : file})
        //     this.setState( prevState => ({ newCarouselData : 
        //         {...prevState.newCarouselData, PageLogo : reader.result}
        //     }))
        //   };
        //   reader.readAsDataURL(file);
    }
      ImageName2Upload = (event) => {
        let file = event.target.files[0];
        var self = this;
        let reader = new FileReader();
        imageCompression(file, options)
            .then(function (compressedFile) {
                self.setState({ Image: compressedFile })
                reader.readAsDataURL(compressedFile);
                reader.onloadend = function () {
                    // self.setState(prevState => ({ newCarouselData : 
                    //     {...prevState.newCarouselData,
                    //         PageLogo: reader.result,
                    //     },
                    //     }))
                    self.setState({ BannerImage: reader.result,BannerImage1: reader.result,ImageName2:file.name })
                }
            })
            .catch(function (error) {
                console.log(error);
            });
        // let reader = new FileReader();
        // reader.onload = () => {
        //     this.setState({ image : file})
        //     this.setState( prevState => ({ newCarouselData : 
        //         {...prevState.newCarouselData, PageLogo : reader.result}
        //     }))
        //   };
        //   reader.readAsDataURL(file);
    }
    deleteImage1() {
        this.setState({ BackGroundImage: '',BackGroundImage1: '',ImageName1:'' })
    }
     deleteImage2() {
        this.setState({BannerImage: '',BannerImage1: '',ImageName2:'' })
    }
    render() {
        const { t } = this.props;
        return (
            <div>
                <div className="progressbar-heading grids-heading">
                    <h2>Company Branding</h2>
                </div>
                <div className="panel panel-widget forms-panel w3-last-form setting-layout">
                    <div className=" forms add-device setting-panel">
                        <div className="form-three widget-shadow">
                            <div className=" panel-body-inputin">
                                <form>
                                    <div className="form-group">
                                        <div className="row">
                                            <div className="col-md-2 radio-label">
                                                <label htmlFor="EmailSubject" className="form-label">Background Image</label>
                                            </div>

                                            <div className="col-sm-9 image-width-100">
                                                {
                                                    this.state.BackGroundImage1 ?
                                                        <div>
                                                            <img src={this.state.BackGroundImage1} width="300px" height="auto" />
                                                            <button type="button" className="btn btn-primary del-img" onClick={() => { this.deleteImage1() }}>{t('Carousel Setting.Delete Image')}</button>
                                                        </div>
                                                        :
                                                        <div>
                                                            <input type='file' accept="image/*" name={'ApplicationLogo'} onChange={this.ImageName1Upload}
                                                                id="editImageUpload" className="hide_input_type_file" />
                                                            <label for="editImageUpload" className="choose-file-btn">{t('Notification Setting.Select Image')}</label>
                                                        </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <div className="row">
                                            <div className="col-md-2 radio-label">
                                                <label htmlFor="BEmailSubject" className="form-label">Banner Image</label>
                                            </div>

                                            <div className="col-sm-9 image-width-100">
                                                {
                                                    this.state.BannerImage1 ?
                                                        <div>
                                                            <img src={this.state.BannerImage1} width="300px" height="auto" />
                                                            <button type="button" className="btn btn-primary del-img" onClick={() => { this.deleteImage2() }}>{t('Carousel Setting.Delete Image')}</button>
                                                        </div>
                                                        :
                                                        <div>
                                                            <input type='file' accept="image/*" name={'ApplicationLogo1'} onChange={this.ImageName2Upload}
                                                                id="editImageUpload1" className="hide_input_type_file" />
                                                            <label for="editImageUpload1" className="choose-file-btn">{t('Notification Setting.Select Image')}</label>
                                                        </div>
                                                }
                                            </div>
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <div className="row">
                                            <div className="col-md-2 radio-label">
                                                <label htmlFor="SigningText" className="form-label">Signing Text</label>
                                            </div>
                                            <div className="col-md-9">
                                                {/* <textarea
                                                    name="description"
                                                    onChange={this.handleInput}
                                                    value={this.state.Description}
                                                    placeholder={t('Email Setting.description')}
                                                    rows="6" cols="70"
                                                    className="insert-laram-textarea"
                                                >
                                                </textarea> */}
                                                <Editor style={{height:'200px'}} 
                                                    value={this.state.SigningText} 
                                                    onTextChange={(e) => this.handleInput(e)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <div className="col-sm-offset-5 col-sm-6">
                                            <p className='butn-center'>
                                                <button
                                                    type="button"
                                                    className="btn btn-primary general-btn"
                                                    onClick={() => { this.save() }}
                                             
                                                >
                                                    {t('First_Responder.Save')}
                                                </button>

                                                
                                            </p>
                                        </div>
                                    </div>
                                </form>

                            </div>
                        </div>
                    </div>
                </div>
            </div>


        )
    }
}

export default withNamespaces()(withRouter(CompanyBrandingComponent));

